import { fetchWithAuth } from "./client";
import type {
  AdminSessionDetail,
  AdminSessionListResponse,
} from "./types";

export interface ListSessionsParams {
  user_id?: string;
  status?: "active" | "completed" | "abandoned";
  email?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
}

export async function listSessions(
  params: ListSessionsParams = {}
): Promise<AdminSessionListResponse> {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== "") qs.set(k, String(v));
  }
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return fetchWithAuth<AdminSessionListResponse>(`/api/admin/sessions${suffix}`);
}

export async function getSessionDetail(id: string): Promise<AdminSessionDetail> {
  return fetchWithAuth<AdminSessionDetail>(`/api/admin/sessions/${id}`);
}
